import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { typographyDefinition } from "../../theme/typography";
import { responsiveCard } from "../../utils/responsive";

export const titleStyle = recipe({
  base: {
    textAlign: "left",
    width: "100%",
    flexGrow: 1,
    alignSelf: "flex-start",
  },
  variants: {
    headerDirection: {
      horizontal: {
        fontWeight: "bold",
        ...responsiveCard({
          400: {
            ...typographyDefinition.bodyL,
            fontWeight: "bold",
          },
        }),
      },
      vertical: {
        fontWeight: "bold",
        ...responsiveCard({
          500: {
            ...typographyDefinition.bodyL,
            fontWeight: "bold",
          },
        }),
      },
    },
  },
  defaultVariants: {
    headerDirection: "horizontal",
  },
});

export const contentStyle = recipe({
  base: {
    overflow: "hidden",
  },
});

export const padderStyle = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacings.m,
    gap: theme.spacings.s,
    ...responsiveCard({
      400: {
        paddingTop: theme.spacings.l,
        gap: theme.spacings.m,
      },
    }),
  },
  variants: {},
});

export const handleStyle = recipe({
  base: {},
});

export const iconStyle = recipe({
  base: {},
  variants: {
    open: {
      true: {
        transform: "rotate(180deg)",
      },
    },
  },
});
